import { scrollTo } from 'platform/utilities/scroll';
// disable smooth scrolling for a11y https://va.ghe.com/software/va.gov-team/issues/9601
export function scrollerTo(name) {
  scrollTo(name, {
    duration: 0,
    delay: 0,
    smooth: false,
  });
}
